import {
  createLoomWingControlSurfacePose,
  parseLoomWingControlSurfaceCollection,
  updateLoomWingControlSurfacePose,
  type LoomWingControlSurfacePose,
} from "./loomWingControlSurfaceContract";
import { OPENVSP_WING_CONTROL_CANARY_GENERATED } from "./openvspWingControlCanary.generated";

export type AirshowControlDemoCase = "port-only" | "starboard-only" | "symmetric" | "antisymmetric";

export const AIRSHOW_CONTROL_IMPORT_DEFINITION_REVISION =
  OPENVSP_WING_CONTROL_CANARY_GENERATED.definitionRevision;

export const CESSNA_AIRSHOW_CONTROL_COLLECTION = parseLoomWingControlSurfaceCollection(
  OPENVSP_WING_CONTROL_CANARY_GENERATED.definition,
);

export const AIRSHOW_CONTROL_IMPORT_RECEIPT =
  OPENVSP_WING_CONTROL_CANARY_GENERATED.receipt;

export const AIRSHOW_CONTROL_IMPORT_ARCHIVE_MEMBER_PATH =
  OPENVSP_WING_CONTROL_CANARY_GENERATED.archiveMemberPath;

export const AIRSHOW_CONTROL_IMPORT_STORAGE_KEY = [
  "loom.airshow-openvsp-control-pose/v1",
  AIRSHOW_CONTROL_IMPORT_RECEIPT.source.sha256,
  AIRSHOW_CONTROL_IMPORT_DEFINITION_REVISION,
].join(":");

export const AIRSHOW_CONTROL_DEMO_CASES = [
  { id: "port-only", label: "Port only", port: 10, starboard: 0 },
  { id: "starboard-only", label: "Starboard only", port: 0, starboard: 10 },
  { id: "symmetric", label: "Symmetric +10° / +10°", port: 10, starboard: 10 },
  { id: "antisymmetric", label: "Antisymmetric −10° / +10°", port: -10, starboard: 10 },
] as const;

export function airshowControlDemoPose(
  demoCase: AirshowControlDemoCase,
): LoomWingControlSurfacePose {
  const id = CESSNA_AIRSHOW_CONTROL_COLLECTION.controlSurfaces[0]!.id;
  const pose = createLoomWingControlSurfacePose(
    CESSNA_AIRSHOW_CONTROL_COLLECTION,
    AIRSHOW_CONTROL_IMPORT_DEFINITION_REVISION,
    id,
  );
  if (demoCase === "port-only") {
    return updateLoomWingControlSurfacePose(
      CESSNA_AIRSHOW_CONTROL_COLLECTION, pose, id,
      { mode: "independent", portDeflectionDeg: 10, starboardDeflectionDeg: 0 },
    );
  }
  if (demoCase === "starboard-only") {
    return updateLoomWingControlSurfacePose(
      CESSNA_AIRSHOW_CONTROL_COLLECTION, pose, id,
      { mode: "independent", portDeflectionDeg: 0, starboardDeflectionDeg: 10 },
    );
  }
  return updateLoomWingControlSurfacePose(
    CESSNA_AIRSHOW_CONTROL_COLLECTION, pose, id,
    { mode: demoCase, starboardDeflectionDeg: 10 },
  );
}

export function airshowControlDemoCaseForPose(
  pose: LoomWingControlSurfacePose,
): AirshowControlDemoCase | null {
  const state = pose.states[0];
  if (!state) return null;
  return AIRSHOW_CONTROL_DEMO_CASES.find(({ id, port, starboard }) => (
    state.portDeflectionDeg === port
    && state.starboardDeflectionDeg === starboard
    && state.mode === (id === "symmetric" || id === "antisymmetric" ? id : "independent")
  ))?.id ?? null;
}
